import { produce } from 'immer';

import {
  SET_FORM_ID,
  SET_FORM_DATA,
  SET_FIELD_VALUE,
  SET_FIELD_ERROR,
  SET_SUBMITTING_FORM,
  SET_CURRENT_PAGE,
  SET_ERROR,
  SET_DATE_RANGE_VALUES,
  SET_FORM_ENTRIES,
  SUBMIT_FORM_SUCCESS,
  SUBMIT_FORM_ERROR,
  SET_SUCCESS_MESSAGE,
  SET_DEFAULT_FIELD_VALUE,
  SUBMIT_FORM_FOR_VALIDATION,
  SET_SINGLE_CHECKBOX_VALUE,
  SET_MULTIPLE_CHECKBOX_VALUE,
} from './types';

const initialSettings = {
  recaptcha: {
    siteKey: null,
  },
};

const initialStatus = {
  isLoading: true,
  isSubmitting: false,
  hasSuccess: false,
  hasError: false,
  messages: {
    success: null,
  },
  validation: {
    sent: false,
  }
};

const initialPagingInfo = {
  pageIndex: 0,
  pageCount: 0,
  currentPageId: null,
};

const initialFormData = {
  formId: null,
  data: {},
  fields: [],
  entries: [],
  fieldErrors: [],
  groups: [],
  defaultLanguage: null,
  pagingInfo: initialPagingInfo,
  status: initialStatus,
  settings: {},
};

let initialState = {
  settings: initialSettings,
};

export default produce((state, action) => {
  switch (action.type) {
    case SET_FORM_ID: {
      const { formId } = action || {};
      state[formId] = initialFormData;
      return;
    }
    case SET_FORM_DATA: {
      const { fields, formId, groups, defaultLanguage, settings } = action || {};
      state[formId].fields = fields;
      state[formId].formId = formId;
      state[formId].groups = groups;
      state[formId].defaultLanguage = defaultLanguage;
      state[formId].status.isSubmitting = false;
      state[formId].status.isLoading = false;
      state[formId].status.hasSuccess = false;
      state[formId].status.hasError = false;
      state[formId].settings = settings;
      return;
    }
    case SET_CURRENT_PAGE: {
      const { formId, pageId, pageIndex, pageCount } = action || {};
      state[formId].pagingInfo.currentPageId = pageId;
      state[formId].pagingInfo.pageIndex = pageIndex;
      state[formId].pagingInfo.pageCount = pageCount;
      return;
    }
    case SET_FIELD_VALUE: {
      const { formId, id, value } = action || {};
      state[formId].data[id] = value;
      return;
    }
    case SET_DEFAULT_FIELD_VALUE: {
      const { formId, value } = action || {};
      state[formId].data = {
        ...state[formId].data,
        ...value
      };
      return;
    }
    case SET_SINGLE_CHECKBOX_VALUE: {
      const { formId, id, value } = action || {};
      state[formId].data[id] = value;
      return;
    }
    case SET_MULTIPLE_CHECKBOX_VALUE: {
      const { formId, id, label, value } = action || {};
      const checked = state[formId].data[id] || [];
      if (value) state[formId].data[id] = [ ...checked, label ]
      else state[formId].data[id] = checked.filter(v => v !== label);
      return;
    }
    case SET_DATE_RANGE_VALUES: {
      const { formId, id, value, dateType } = action || {};
      state[formId].data[id][dateType] = value;
      return;
    }
    case SET_FIELD_ERROR: {
      const { formId, value } = action || {};
      state[formId].fieldErrors = value;
      return;
    }
    case SET_SUBMITTING_FORM: {
      const { formId, isSubmitting } = action || {};
      state[formId].status.isSubmitting = isSubmitting;
      return;
    }
    case SUBMIT_FORM_SUCCESS: {
      const { formId } = action || {};
      state[formId].status.hasError = false;
      state[formId].status.isSubmitting = false;
      state[formId].status.hasSuccess = true;
      state[formId].status.validation.sent = false;
      return;
    }
    case SUBMIT_FORM_FOR_VALIDATION: {
      const { formId } = action || {};
      state[formId].status.validation.sent = true;
      state[formId].status.isSubmitting = false;
      state[formId].status.hasSuccess = false;
      state[formId].status.hasError = false;
      return;
    }
    case SET_SUCCESS_MESSAGE: {
      const { formId, message } = action || {};
      state[formId].status.messages.success = message;
      return;
    }
    case SUBMIT_FORM_ERROR: {
      const { formId } = action || {};
      state[formId].status.hasError = true;
      state[formId].status.isSubmitting = false;
      state[formId].status.validation.sent = false;
      return;
    }
    case SET_FORM_ENTRIES: {
      const { formId, entries } = action || {};
      const entryObject = {};
      entries.map(entry => {
        if (!entry) return null;
        entryObject[entry.id] = entry.entries;
        return entryObject;
      });
      state[formId].entries = entryObject;
      return;
    }
    case SET_ERROR: {
      const { formId } = action || {};
      state[formId].status.hasError = true;
      state[formId].status.isSubmitting = false;
      return;
    }
    default:
      return state;
  }
}, initialState);
